<template>
  <div class="border-solid border-0 border-t border-soft p-5 text-sm cursor-auto">
    <div v-if="isTypeNoCondition" class="text-gray-dark text-center">
      This is active when no other condition is met.
    </div>

    <div v-else class="text-gray-dark text-left">
      <label class="font-bold">Case Type</label>
      <condition-case-picker :selected-condition-case="selectedCase"
                             class="w-full"
                             @expression-change="updateCase"
      />

      <condition-case-operator-status v-if="isTypeOperatorAvailable"
                                      :is-online="expressionValue"
                                      @condition-change="updateCase"
      />

      <condition-case-day v-if="isTypeDay"
                          :value="expressionValue"
                          @input="updateCase"
      />

      <condition-case-time-between v-if="isTypeTimeBetween"
                                   :time-between="expressionValue"
                                   @condition-change="updateCase"
      />

      <condition-case-channel-type v-if="isTypeChannelType"
                                   :value="expressionValue"
                                   @input="updateCase"
      />

      <condition-case-browser-url v-if="isTypeBrowserUrl"
                                  :value="expressionValue"
                                  :state-id="transition.state"
                                  @input="updateCase"
      />

      <condition-case-context v-if="isTypeContext"
                              :expression-type="expressionType"
                              :value="expressionValue"
                              @input="updateCase"
      />

      <div class="flex mt-6">
        <base-button @click="deleteCase"
                     variant="transparent-error"
                     class="mx-auto test-delete-case"
        >
          Delete Case
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
import ConditionCaseOperatorStatus from './case-editors/ConditionCaseOperatorStatus'
import ConditionCaseDay from './case-editors/ConditionCaseDay'
import ConditionCaseTimeBetween from './case-editors/ConditionCaseTimeBetween'
import ConditionCaseChannelType from './case-editors/ConditionCaseChannelType'
import ConditionCasePicker from './ConditionCasePicker'
import keys from 'ramda/src/keys'
import { EXPRESSION_TYPES, INPUT_TYPES } from '@/utils/bot-json.constants'
import { CONDITION_CASES } from '@/store/constants'
import ConditionCaseBrowserUrl from '@/components/editor/condition/case-editors/ConditionCaseBrowserUrl.vue'
import ConditionCaseContext from '@/components/editor/condition/case-editors/ConditionCaseContext.vue'

export default {
  name: 'ConditionCaseEditor',

  components: {
    ConditionCaseOperatorStatus,
    ConditionCaseDay,
    ConditionCaseTimeBetween,
    ConditionCasePicker,
    ConditionCaseChannelType,
    ConditionCaseBrowserUrl,
    ConditionCaseContext
  },

  props: {
    transition: {
      type: Object,
      required: true
    }
  },

  computed: {
    expression() {
      return this.transition.condition.expression
    },

    expressionType() {
      return keys(this.expression)[0]
    },

    expressionValue() {
      return this.expression[this.expressionType]
    },

    conditionInput() {
      return this.transition.condition.input
    },

    isTypeNoCondition() {
      return this.selectedCase === CONDITION_CASES.NO_CONDITION
    },

    isTypeOperatorAvailable() {
      return this.selectedCase === CONDITION_CASES.OPERATOR_AVAILABLE
    },

    isTypeDay() {
      return this.selectedCase === CONDITION_CASES.DAY
    },

    isTypeTimeBetween() {
      return this.selectedCase === CONDITION_CASES.TIME_BETWEEN
    },

    isTypeChannelType() {
      return this.selectedCase === CONDITION_CASES.CHANNEL_TYPE
    },

    isTypeBrowserUrl() {
      return this.selectedCase === CONDITION_CASES.BROWSER_URL
    },

    isTypeContext() {
      return this.selectedCase === CONDITION_CASES.CONTEXT
    },

    selectedCase() {
      if (this.expressionType === EXPRESSION_TYPES.TRUE && this.conditionInput === INPUT_TYPES.NONE) return CONDITION_CASES.NO_CONDITION
      if (this.expressionType === EXPRESSION_TYPES.OPERATOR_AVAILABLE && this.conditionInput === INPUT_TYPES.NONE) return CONDITION_CASES.OPERATOR_AVAILABLE
      if (this.expressionType === EXPRESSION_TYPES.DAYS_OF_WEEK && this.conditionInput === INPUT_TYPES.NONE) return CONDITION_CASES.DAY
      if (this.expressionType === EXPRESSION_TYPES.TIME_BETWEEN && this.conditionInput === INPUT_TYPES.NONE) return CONDITION_CASES.TIME_BETWEEN
      if (this.expressionType === EXPRESSION_TYPES.ENUM && this.conditionInput === INPUT_TYPES.CHANNEL_TYPE) return CONDITION_CASES.CHANNEL_TYPE
      if (this.expressionType === EXPRESSION_TYPES.KEY_REGEX && this.conditionInput === INPUT_TYPES.METADATA) return CONDITION_CASES.BROWSER_URL
      if ([EXPRESSION_TYPES.KEY_EQUALS, EXPRESSION_TYPES.KEY_REGEX].includes(this.expressionType) && this.conditionInput === INPUT_TYPES.CONTEXT) return CONDITION_CASES.CONTEXT

      return null
    }
  },

  methods: {
    updateCase(condition) {
      this.$emit('update-case', {
        stateId: this.transition.state,
        condition
      })
    },

    deleteCase() {
      this.$emit('delete-case')
    }
  }
}
</script>
